import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const userAddressPromise = import("./UserAddress");
export default Auth(lazy(() => userAddressPromise));